import apiService from "./apiServices";


export const fetchAllActivity = async (page,size,token) => {
    try {
      const response = await apiService(`/activity-logs/logs/all?page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'Activity logs is failed. Please try again.');
    }
  }

  export const fetchAllActivityByEntityId = async (id,page,size,token) => {
    try {
      const response = await apiService(`/activity-logs/logs/entity-public-id?entityPublicId=${id}&page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'Activity logs is failed. Please try again.');
    }
  }